import { Switch } from "@headlessui/react";
import { clsx } from "clsx";

export function SwitchControl({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <Switch
      checked={checked}
      onChange={onChange}
      className={clsx(
        "relative mt-1 inline-flex h-6 w-11 items-center rounded-full",
        {
          "bg-blue-600": checked,
          "bg-gray-200": !checked,
        },
      )}
    >
      <span
        className={`${
          checked ? "translate-x-6" : "translate-x-1"
        } inline-block h-4 w-4 transform rounded-full bg-white transition`}
      />
    </Switch>
  );
}
